"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Package = function Package(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.562 15.505l-6.25 3.592a.625.625 0 01-.624 0l-6.25-3.593a.624.624 0 01-.313-.541V9.027c0-.223.119-.43.313-.54l1.66-.955a.312.312 0 01.312 0l6.934 4.018c.097.056.156.16.156.271v1.58a.156.156 0 00.236.135l1.486-.885a.314.314 0 00.153-.27v-1.737a.157.157 0 00-.078-.136L9.372 6.496a.157.157 0 010-.272l2.316-1.331c.193-.11.43-.11.623 0l6.252 3.593a.624.624 0 01.312.542v5.934c0 .224-.12.43-.313.543zm-9.687-1.852a.313.313 0 00-.157-.27L6.61 12.17a.156.156 0 00-.234.135v2.114c0 .112.06.216.157.271l2.109 1.213a.156.156 0 00.234-.136v-2.114z"
  }));
};

var _default = (0, _react.forwardRef)(Package);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Package, "Package", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Package.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Package.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9QYWNrYWdlLnRzeCJdLCJuYW1lcyI6WyJQYWNrYWdlIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLE9BQXVFLEdBQUcsU0FBMUVBLE9BQTBFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzlFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLElBQUksRUFBQyxjQURQO0FBRUUsSUFBQSxDQUFDLEVBQUM7QUFGSixJQURGLENBRDhFO0FBQUEsQ0FBaEY7O2VBU2UsdUJBQVdGLE9BQVgsQzs7Ozs7Ozs7Ozs7OzswQkFUVEEsTyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgUGFja2FnZTogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTguNTYyIDE1LjUwNWwtNi4yNSAzLjU5MmEuNjI1LjYyNSAwIDAxLS42MjQgMGwtNi4yNS0zLjU5M2EuNjI0LjYyNCAwIDAxLS4zMTMtLjU0MVY5LjAyN2MwLS4yMjMuMTE5LS40My4zMTMtLjU0bDEuNjYtLjk1NWEuMzEyLjMxMiAwIDAxLjMxMiAwbDYuOTM0IDQuMDE4Yy4wOTcuMDU2LjE1Ni4xNi4xNTYuMjcxdjEuNThhLjE1Ni4xNTYgMCAwMC4yMzYuMTM1bDEuNDg2LS44ODVhLjMxNC4zMTQgMCAwMC4xNTMtLjI3di0xLjczN2EuMTU3LjE1NyAwIDAwLS4wNzgtLjEzNkw5LjM3MiA2LjQ5NmEuMTU3LjE1NyAwIDAxMC0uMjcybDIuMzE2LTEuMzMxYy4xOTMtLjExLjQzLS4xMS42MjMgMGw2LjI1MiAzLjU5M2EuNjI0LjYyNCAwIDAxLjMxMi41NDJ2NS45MzRjMCAuMjI0LS4xMi40My0uMzEzLjU0M3ptLTkuNjg3LTEuODUyYS4zMTMuMzEzIDAgMDAtLjE1Ny0uMjdMNi42MSAxMi4xN2EuMTU2LjE1NiAwIDAwLS4yMzQuMTM1djIuMTE0YzAgLjExMi4wNi4yMTYuMTU3LjI3MWwyLjEwOSAxLjIxM2EuMTU2LjE1NiAwIDAwLjIzNC0uMTM2di0yLjExNHpcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihQYWNrYWdlKTtcbiJdfQ==